import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from "./Navbar";
import Footer from "./Footer.jsx";
import './LegalPages.css';

const PrivacyPolicy = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="legal-page-container">
        <div className="legal-content">
          <div className="legal-header">
            <h1>Privacy Policy</h1>
            {/* <p>Last Updated: January 1, 2025</p> */}
          </div>

          <div className="legal-section">
            <h2>1. Information We Collect</h2>
            <p>At Royal Heritage Fiesta, we collect information that you voluntarily provide to us when you:</p>
            <ul>
              <li>Register for events or book tickets</li>
              <li>Contact us via our forms or WhatsApp</li>
              <li>Subscribe to our newsletters</li>
              <li>Submit stall booking inquiries</li>
            </ul>
            <p>This information may include your name, email address, phone number, event preferences, and any other details you choose to share.</p>
          </div>

          <div className="legal-section">
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Process your event registrations and ticket bookings</li>
              <li>Communicate with you about events, updates, and promotions</li>
              <li>Improve our services and customer experience</li>
              <li>Respond to your inquiries and support requests</li>
              <li>Send you important information about event changes or cancellations</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>3. Information Sharing</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
            <ul>
              <li>With your explicit consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights, privacy, safety, or property</li>
              <li>With service providers who assist our operations (under confidentiality agreements)</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>4. Data Security</h2>
            <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no internet transmission is 100% secure, and we cannot guarantee absolute security.</p>
          </div>

          <div className="legal-section">
            <h2>5. Cookies & Tracking</h2>
            <p>Our website may use cookies to enhance your browsing experience. You can set your browser to refuse cookies, but this may limit some website functionality.</p>
          </div>

          <div className="legal-section">
            <h2>6. Third-Party Links</h2>
            <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites.</p>
          </div>

          <div className="legal-section">
            <h2>7. Children's Privacy</h2>
            <p>Our services are not directed to individuals under the age of 13. We do not knowingly collect personal information from children under 13.</p>
          </div>

          <div className="legal-section">
            <h2>8. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt-out of marketing communications</li>
            </ul>
            <p>To exercise these rights, please contact us at <a href="mailto:royalheritagefiesta@gmail.com">royalheritagefiesta@gmail.com</a></p>
          </div>

          <div className="legal-section">
            <h2>9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated revision date.</p>
          </div>

          <div className="legal-section">
            <h2>10. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us:</p>
            <ul>
              <li>Email: <a href="mailto:royalheritagefiesta@gmail.com">royalheritagefiesta@gmail.com</a></li>
              <li>Phone: +91 99662 52374</li>
              <li>Address: Road No. 2, Durgam Cheruvu, Hyderabad - 500032</li>
            </ul>
          </div>

          <div className="legal-footer">
            <Link to="/" className="back-home-btn">← Back to Home</Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;